import React, { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';

import useSearch from '../../hooks/useSearch';
import { useTabs } from '../../hooks/useTabs';
import { useVisibleTabs } from '../../hooks/lockedFeatures/useVisibleTabs';
import { useSaveSettings } from '../../hooks/useSaveSettings';
import { CATEGORIES, SUBCATEGORIES } from '../../common/categories';
import { fieldsReducer, initFieldsState, mapToSettings } from './advancedReducer';

import Category from '../../components/Category/Category';
import Maintenance from '../../components/Maintenance/Maintenance';
import ElasticConfig from '../../components/ElasticConfig/ElasticConfig';
import AdvancedConfig from '../../components/AdvancedConfig/AdvancedConfig';
import { filterFieldsBySystemMode } from '../../common/utils';
import { USER_ENGAGEMENT_PAGE_KEYS } from '@silverfort-nodelibs/common/utils/consts';
import { httpPost } from '../../../utils';
import { useIsCloudOnly } from '../../hooks/featureFlags/useIsCloudOnly';

const { ADVANCED } = CATEGORIES;
const { MAINTENANCE, ADVANCED_CONFIG, ELASTIC_CONFIG } = SUBCATEGORIES;

const Advanced = ({ saveFunc, disableSave, systemMode }) => {
    const settings = useSelector((state) => state.settings.settings);
    const schemas = useSelector((state) => state.settings.schemas);
    const towerSchema = useSelector((state) => state.settings.towerSchema);
    const isCloudOnly = useIsCloudOnly();

    const [fields, dispatch] = useReducer(
        fieldsReducer,
        { settings, schemas, towerSchema, isCloudOnly },
        initFieldsState
    );
    const visibleFields = useSearch(useVisibleTabs(fields));
    const [selectedTab, setSelectedTab] = useTabs(ADVANCED, visibleFields);
    const [save, discard] = useSaveSettings(saveFunc, settings, mapToSettings, fields, selectedTab, dispatch, {
        schemas,
        towerSchema
    });

    useEffect(() => {
        httpPost('/data/userEngagement', { pageId: USER_ENGAGEMENT_PAGE_KEYS.SETTINGS_ADVANCED });
    }, []);

    let content = null;
    if (visibleFields[MAINTENANCE.ID] && selectedTab === MAINTENANCE.ID) {
        content = (
            <Maintenance
                fields={filterFieldsBySystemMode(visibleFields[MAINTENANCE.ID].fields, systemMode)}
                allFields={fields[MAINTENANCE.ID].fields}
                settings={settings}
                dispatch={dispatch}
            />
        );
    } else if (visibleFields[ADVANCED_CONFIG.ID] && selectedTab === ADVANCED_CONFIG.ID) {
        content = (
            <AdvancedConfig
                fields={filterFieldsBySystemMode(visibleFields[ADVANCED_CONFIG.ID].fields, systemMode)}
                allFields={fields[ADVANCED_CONFIG.ID].fields}
                dispatch={dispatch}
            />
        );
    } else if (visibleFields[ELASTIC_CONFIG.ID] && selectedTab === ELASTIC_CONFIG.ID) {
        content = <ElasticConfig fields={visibleFields[ELASTIC_CONFIG.ID].fields} dispatch={dispatch} />;
    }

    return (
        <Category
            category={ADVANCED}
            fields={fields}
            visibleFields={visibleFields}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            saveSettings={save}
            discard={() => discard(false)}
            discardAll={() => discard(true)}
            disableSave={disableSave}>
            {content}
        </Category>
    );
};

export default Advanced;
